/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-08-01 13:50:03
 * @LastEditors: jyf
 * @LastEditTime: 2022-08-08 14:30:28
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace DataAnalysis {
    /**
    * 近6月发货量/运费GET
    */
    export var CarFreightResult = (): Promise<any> => {
        return Get(`/msls/DataAnalysis/CarFreightResult`, {});
    };

    /**
    * GET
    本月/本季/全年运费
    */
    export var FreightAnalysisResult = (): Promise<any> => {
        return Get(`/msls/DataAnalysis/FreightAnalysisResult`, {});
    };
    /**
     * 本月线路发货统计
     */
    export var LineDeliveryResult = (): Promise<any> => {
        return Get(`/msls/DataAnalysis/LineDeliveryResult`, {});
    };
    /**
  * 本月物流成本
  */
    export var LogisticsCostResult = (): Promise<any> => {
        return Get(`/msls/DataAnalysis/LogisticsCostResult`, {});
    };
    /**
* 物流运输可视化
*/
    export var LogisticsTransportResult = (): Promise<any> => {
        return Get(`/msls/DataAnalysis/LogisticsTransportResult`, {});
    };
    /**
    * 本月/本季/全年发运(车)
    */
    export var SentCarAnalysisResult = (): Promise<any> => {
        return Get(`/msls/DataAnalysis/SentCarAnalysisResult`, {});
    };
    /**
    * 本月/本季/全年发运(车) 及时率结果
    */
    export var TimelinessRateResult = (): Promise<any> => {
        return Get(`/msls/DataAnalysis/TimelinessRateResult`, {});
    };
    /**
    * 累计交易额数据分析
    */
    export var TradeTotalAmountResult = (): Promise<any> => {
        return Get(`/msls/DataAnalysis/TradeTotalAmountResult`, {});
    };
    /**
    * 实时订单
    */
    export var RealTimeOrderResult = (): Promise<any> => {
        return Get(`/msls/DataAnalysis/RealTimeOrderResult`, {});
    };
    /**
    * 在途车辆分布
    */
    export var OnlineCarResult = (): Promise<any> => {
        return Get(`/msls/DataAnalysis/OnlineCarResult`, {});
    };
}

